import React from 'react';

import { useSidenavContext } from '../context';
import Footer, { ComponentProps as FooterProps } from './Footer';
import Head from './Head';
import List from './List';
import { StyledMenu, MenuOffset } from './styles';

export type ComponentProps = FooterProps;

const Menu: React.FC<ComponentProps> = props => {
  const { isOpen, items } = useSidenavContext();
  return (
    <StyledMenu isOpen={isOpen}>
      <MenuOffset>
        <Head />
        <List items={items} />
        <Footer {...props} />
      </MenuOffset>
    </StyledMenu>
  );
};
export default Menu;
